import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function MoonWidget({ language }) {
    const [moon, setMoon] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API}/api/sleep/moon`);
                setMoon(res.data);
            } catch (e) {}
        })();
    }, []);

    if (!moon) return null;

    const name = language === 'de' ? moon.name_de : moon.name_en;
    const hint = language === 'de' ? moon.sleep_hint_de : moon.sleep_hint_en;

    return (
        <div className="flex items-center gap-3 p-3 rounded-xl bg-indigo-50 dark:bg-indigo-950/20 border border-indigo-200 dark:border-indigo-800" data-testid="moon-widget">
            <span className="text-3xl shrink-0">{moon.emoji}</span>
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                    <span className="font-semibold text-sm">{name}</span>
                    <span className="text-[10px] text-muted-foreground">{moon.illumination_pct}%</span>
                    {moon.traveling && <span className="text-[9px] bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300 px-1.5 py-0.5 rounded">✈️ {moon.destination}</span>}
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">{hint}</p>
            </div>
        </div>
    );
}
